import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

// used to create fake backend
import { fakeBackendProvider } from './_helpers';

import { AppRoutingModule } from './app-routing.module';
import { JwtInterceptor, ErrorInterceptor } from './_helpers';
import { AppComponent } from './app.component';
import { AlertComponent } from './_components';
import { HomeComponent } from './home';
// import { CoursePlayerComponent } from './courses/course-player.component'

import { WINDOW_PROVIDERS } from './_helpers/window-provider';

import { HammerModule, HAMMER_GESTURE_CONFIG, HammerGestureConfig } from '@angular/platform-browser';

import { CourseLandingPageComponent } from './courses/course-landing-page/course-landing-page.component';

import { reducers } from './courses/course-player/reducers';
import { CoursePlayerModule } from './courses/course-player/course-player.module';
import { CoursePlayerEffects } from './courses/course-player/course-player.effects';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

declare var Hammer: any;

export class MyHammerConfig extends HammerGestureConfig {
    public buildHammer(element: HTMLElement): any {
        return new (window as any).Hammer(element, { touchAction: 'pan-y, pan-x' });
    }
}

@NgModule({
    imports: [
        BrowserModule,
        ReactiveFormsModule,
        HttpClientModule,
        AppRoutingModule,           
        HammerModule,
        CommonModule,
        CoursePlayerModule,
        StoreModule.forRoot(reducers),
        EffectsModule.forRoot([CoursePlayerEffects]),
        FormsModule
    ],
    declarations: [
        AppComponent,
        AlertComponent,
        HomeComponent,        
        CourseLandingPageComponent
    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        WINDOW_PROVIDERS,
        // provider used to create fake backend
        fakeBackendProvider,
        {
            provide: HAMMER_GESTURE_CONFIG,
            useClass: MyHammerConfig
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { };